<!-- 地图 -->

<template>
  <div class="echarts">
    <div ref="mymap" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "../../node_modules/echarts/map/js/china";
var mycharts = null;
var option = {
  //地图配置
  tooltip: {
    show: false,
  },
  geo: {
    map: "china",
    roam: false, //不开启缩放和平移
    zoom: 1.2, //视角缩放比例
    zlevel: 1,
    label: {
      normal: {
        show: false,
        fontSize: "12",
        color: "rgba(255,255,255,0.7)"
      },
      emphasis: {
        show: false,
        textStyle: {

          color: "#fff"
        }
      }
    },
    itemStyle: {
      normal: {
        areaColor: "#092864",
        borderColor: "rgba(43, 196, 243, 1)",
        borderWidth: 1
      },
      emphasis: {
        areaColor: "#2B91B7"
      }
    },
    regions: [
    ] // 色块的设置
  },
  series: [
    {
      type: 'map',
      map: 'china',
      zoom: 1.2,
      z: 1,
      roam: false,
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false,
          textStyle: {
            color: "#fff"
          }
        }
      },
      itemStyle: {
        normal: {
          shadowColor: '#003585',
          shadowOffsetX: 5,
          shadowOffsetY: 20
        },
        emphasis: {
          show: false,
          label: {
            show: false
          }
        }
      },
      data: [
        {
          name: '南海诸岛',
          itemStyle: {
            opacity: 0
          }
        },

      ]
    },
    {
      // 散点的chart配置
      tooltip: { show: false },
      name: "运力",
      zlevel: 2,
      coordinateSystem: "geo",
      symbolSize: 2,
      type: "scatter",
      // type: "effectScatter",
      // rippleEffect: {
      //   //涟漪特效
      //   period: 10, //特效动画时长
      //   scale: 3, //波纹的最大缩放比例
      //   brushType: "stroke" //波纹的绘制方式：stroke | fill
      // }
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: "#00fecb"
        },
        emphasis: {
          borderColor: "#fff",
          borderWidth: 1
        }
      },
      data: []
    },
    {
      // 散点的chart配置
      tooltip: { show: false },
      name: "运力",
      zlevel: 3,
      coordinateSystem: "geo",
      symbolSize: 7,
      type: "effectScatter",
      rippleEffect: {
        //涟漪特效
        period: 3, //特效动画时长
        scale: 5, //波纹的最大缩放比例
        brushType: "stroke" //波纹的绘制方式：stroke | fill
      },
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: "#fdb933"
        },
        emphasis: {
          borderColor: "#fff",
          borderWidth: 1
        }
      },
      data: [
        //   [109.580684, 19.520863],
        // [128.84079, 47.727648]
      ]
    },
    {
      // 飞线的配置
      type: "lines",
      coordinateSystem: "geo",
      animation: false,
      zlevel: 4,
      large: true,
      effect: {
        show: true,
        period: 4,
        symbol: "triangle",
        symbolSize: 8,
        trailLength: 0.5
      },
      lineStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 1,
              color: "rgba(241,255,0,0)"
            },
            {
              offset: 0,
              color: "rgba(241,255,0,1)"
            }
          ],
            false
          ),
          width: 0,
          curveness: 0.3
        }
      },
      data: [
        // [
        //   [109.580684, 19.520863],
        //   [128.84079, 47.727648]
        // ]
      ]
    }
  ] // 飞线和散点设置
};
var diandata = [];
var fiydata = [];
var allPointData = {};
var colordata = [];
var effectScatterData = []
export default {
  name: "",
  props: {
    chartMap: {
      type: Object,
      default: function () {
        return {
          allPointData: {}
        };
      }
    },
    chartMapfly: {
      type: Object,
      default: function () {
        return {
          dataErr: []
        };
      }
    },
    chartMapcolor: {
      type: Object,
      default: function () {
        return {
          colorData: []
        };
      }
    }
  },
  data () {
    return {

    };
  },
  watch: {
    chartMap: {
      handler (data) {
        this.mapChart(data.allPointData);
      },
      deep: true
    },
    chartMapfly: {
      handler (data) {
        this.loadFly(data.dataErr);
      },
      deep: true
    },
    chartMapcolor: {
      handler (data) {
        this.loadColor(data.colorData);
      },
      deep: true
    }
  },
  mounted () {
    this.initdata(); // 初始化地图
    this.throttle(); // 拦截5秒
  },
  methods: {
    initdata () {
      this.mycharts = this.$echarts.init(this.$refs.mymap); // 初始化图
      this.mycharts.setOption(option);
    },
    loadPoint () {
      option.series[1].data = diandata
      this.mycharts.setOption(option)
      // this.mycharts.appendData({
      //   // 海量数据加载
      //   seriesIndex: 1,
      //   data: diandata
      // });
    },
    loadColor (ColorData) {
      // 加载色块
      // console.log(colorData);
      colordata = ColorData;
      let customSettings = [];
      colordata.forEach(item => {
        // 处理色块数据
        customSettings.push({
          name: item.name,
          itemStyle: {
            areaColor: item.color,
            color: item.color
          }
        });
        option.geo.regions = customSettings;
      });

      this.mycharts.setOption(option);
    },
    loadFly (dataErr) {
      let newdata = [];
      fiydata = []
      effectScatterData = []
      dataErr.forEach(item => {
        newdata.push({
          toname: item.a,
          tovalue1: item.b,
          tovalue2: item.c,
          fromname: item.d,
          fromvalue1: item.e,
          fromvalue2: item.f,
        });
      });
      // console.log(newdata)
      // 去重
      function deWeight () {
        for (var i = 0; i < newdata.length - 1; i++) {
          for (var j = i + 1; j < newdata.length; j++) {
            if (newdata[i].toname == newdata[j].toname && newdata[i].tovalue1 == newdata[j].tovalue2 && newdata[i].tovalue2 == newdata[j].tovalue2 && newdata[i].fromname == newdata[j].fromname && newdata[i].fromvalue1 == newdata[j].fromvalue1 && newdata[i].fromvalue2 == newdata[j].fromvalue2) {
              newdata.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        return newdata;
      }
      var newfiydata = deWeight()
      // console.log(newfiydata)
      newfiydata.forEach(item => {
        let toLongitud = item.tovalue1 / 1000000; //起始经度
        let toLatitudee = item.tovalue2 / 1000000; //起始纬度
        let fromLongitud = item.fromvalue1 / 1000000; //终点经度
        let fromLatitudee = item.fromvalue2 / 1000000; //终点纬度
        fiydata.push([
          [toLongitud, toLatitudee],
          [fromLongitud, fromLatitudee]
        ]);
        effectScatterData.push([toLongitud, toLatitudee], [fromLongitud, fromLatitudee])
        // fiydata.push([
        //   [109.580684, 19.520863],
        //   [128.84079, 47.727648]
        // ]);
      });

      option.series[2].data = effectScatterData;
      option.series[3].data = fiydata;
      this.mycharts.setOption(option);
    },
    mapChart (AllPointData) {
      allPointData = AllPointData; //接收传来的散点值
    },
    throttle () {
      // 拦截散点数据
      let timer = setInterval(() => {
        diandata = Object.values(allPointData);
        this.loadPoint(); // 加载散点
      }, 10000);
      // clearTimeout(timer)
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
  display: flex;
  /* margin: 0 auto; */
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue